import React, { useState, useEffect, createContext } from "react";

export const AppContext = createContext();
export const AppProvider = (props) => {
  const [isAuth, setIsAuth] = useState(
    sessionStorage.getItem("user") ? true : false
  );
  const [userInfo, setUserInfo] = useState({});
  const [userRole, setUserRole] = useState();

  const [submitting, setSubmitting] = useState(false);
  const [requestTypes, setRequestTypes] = useState([]);

  return (
    <AppContext.Provider
      value={[
        [isAuth, setIsAuth],
        [userInfo, setUserInfo],
        [userRole, setUserRole],
        [submitting, setSubmitting],
        [requestTypes, setRequestTypes],
      ]}
    >
      {props.children}
    </AppContext.Provider>
  );
};
